import { IProductNavigation } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing';
import { hasAllIntegrationsPrereq } from '@adaptiva/data-service';

const _configmgrRoute: string = Licensing.PRODUCT_ROUTES.get(Licensing.Products.OneSite.ANYWHERE);

export const ONESITE_ANYWHERE_PRODUCT_NAVIGATION: IProductNavigation = {
	productName: Licensing.Products.OneSite.ANYWHERE,
	route: _configmgrRoute,
	sidenav: {
		productName: 'OneSite',
		sections: [{
			items: [
				{
					display: 'Home',
					route: _configmgrRoute,
					icon: 'faHomeOutline',
				},
				{
					display: 'Live WAN Downloads',
					route: '/live-wan-downloads/download-status',
					icon: 'faChartNetworkOutline',
					linkedRoutes: [
						'/live-wan-downloads/download-status',
						'/live-wan-downloads/paused-downloads',
						'/live-wan-downloads/priority-overrides',
						'/live-wan-downloads/transport-overrides'
					],
				},
				{
					display: 'Content Push',
					route: '/content-push',
					icon: 'faPaperPlaneOutline',
					linkedRoutes: [
						'/content-push/edit/:id',
						'/content-push/download-details/:PolicyID'
					],
				},
				{
					display: 'Content Publication',
					icon: 'faBoxOutline',
					children: [
						{
							display: 'Packages',
							route: _configmgrRoute + '/content/packages',
							linkedRoutes: [_configmgrRoute + '/content/packages/edit/:id'],
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Applications',
							route: _configmgrRoute + '/content/applications',
							linkedRoutes: [_configmgrRoute + '/content/applications/edit/:id'],
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Software Updates',
							route: _configmgrRoute + '/content/software-updates',
							linkedRoutes: [_configmgrRoute + '/content/software-updates/edit/:id'],
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Boot Images',
							route: _configmgrRoute + '/content/boot-images',
							linkedRoutes: [_configmgrRoute + '/content/boot-images/edit/:id'],
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'OS Images',
							route: _configmgrRoute + '/content/os-images',
							linkedRoutes: [_configmgrRoute + '/content/os-images/edit/:id'],
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'OS Upgrade Packages',
							route: _configmgrRoute + '/content/os-installs',
							linkedRoutes: [_configmgrRoute + '/content/os-installs/edit/:id'],
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Driver Packages',
							route: _configmgrRoute + '/content/drivers',
							linkedRoutes: [_configmgrRoute + '/content/drivers/edit/:id'],
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Task Sequences',
							route: _configmgrRoute + '/content/task-sequences',
							linkedRoutes: [_configmgrRoute + '/content/task-sequences/edit/:id'],
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Adaptiva Content',
							route: '/onesite-configmgr/content/adaptiva-content',
							linkedRoutes: ['/content/edit/:id']
						},
					]
				},
				{
					display: 'Settings',
					icon: 'faSlidersH',
					children: [
						{
							display: 'App V',
							route: _configmgrRoute + '/settings/app-v',
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Upload Bandwidth Management',
							route: _configmgrRoute + '/settings/upload-bandwidth',
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Policy Bandwidth Management',
							route: _configmgrRoute + '/settings/policy-bandwidth',
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'DP Bypass',
							route: _configmgrRoute + '/settings/dp-bypass',
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Publication',
							route: _configmgrRoute + '/settings/publication',
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Virtual SMP',
							route: _configmgrRoute + '/settings/vsmp',
							prerequisites: [hasAllIntegrationsPrereq(Licensing.ThirdParty.CONFIGMGR)],
						},
						{
							display: 'Peer-to-Peer PXE',
							route: _configmgrRoute + '/settings/p2p-pxe',
							children: []
						}
					]
				},
			]
		}]
	}
};
